exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-card-component-default{width:100%;padding:10px 30px}.table-card-component-default .button{padding:0;border:none;font-size:25px;height:auto}", ""]);

// exports
